import React from 'react'
import { Result, Button } from 'antd'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  padding: 40px;
  background: transparent;

  .ant-result-title {
    color: hsl(210, 55%, 22%) !important;
    font-size: 72px !important;
    font-weight: 900 !important;
    line-height: 1 !important;
  }

  .ant-result-subtitle {
    color: #4b5563 !important;
    font-size: 18px !important;
    font-weight: 500 !important;
    margin-bottom: 32px !important;
  }

  .ant-result-icon svg {
    fill: hsl(33, 100%, 50%) !important;
  }

  .btn-back {
    background: hsl(33, 100%, 50%) !important;
    border-color: hsl(33, 100%, 50%) !important;
    color: white !important;
    height: 48px !important;
    padding: 0 40px !important;
    font-weight: 700 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
    
    &:hover {
      opacity: 0.9;
      transform: translateY(-1px);
    }
  }
`

const BrandedError = ({ status = '404', title = '404', subTitle = "Oops! The page you're looking for disappeared.", redirect = '/' }) => {
    const history = useHistory()

    return (
        <ErrorContainer>
            <Result
                status={status}
                title={title}
                subTitle={subTitle}
                extra={
                    <Button
                        type="primary"
                        className="btn-back"
                        onClick={() => history.push(redirect)}
                    >
                        Back to Home
                    </Button>
                }
            />
        </ErrorContainer>
    )
}

export default BrandedError
